export default {"src":"/_next/static/media/checkbox-image-dark.7a893f1b.svg","height":100,"width":100};